import React from 'react';

import { ContextProviders } from '../../resources/ContextProviders';
import { GeneralProviders } from '../../resources/GeneralProviders';

import HomeOwnerFlowDialogWrapper from './HomeOwnerFlowDialogWrapper';

const HomeOwnerFlowWidget = () => {
  return (
    <GeneralProviders>
      <ContextProviders>
        <HomeOwnerFlowDialogWrapper />
      </ContextProviders>
    </GeneralProviders>
  );
};

export default HomeOwnerFlowWidget;
